<script setup lang="ts">
import type { Image, PortableTextBlock } from '@sanity/types';
import { computed, type Component } from 'vue';
import type { VideoType } from '@pkg/sanity-utils/constants/video';

const props = defineProps<{
  block?: {
    _type: string;
    _key: string;
    theme: string;
    anchorId?: string;
    content: Array<PortableTextBlock>;
    offsetHeader?: boolean;
    image?: Image;
    video?: {
      url?: string;
      webm?: string;
      ogg?: string;
      fallbackImage?: Image;
      controls: boolean;
      autoplay: boolean;
      videoType?: VideoType;
    };
  };
  config: {
    innerComponent?: Component;
  };
}>();

const data = computed(() => ({
  theme: props.block?.theme,
  content: props.block?.content,
  image: props.block?.image,
  video: props.block?.video,
  offsetHeader: props.block?.offsetHeader,
}));
</script>

<template>
  <component :is="props.config?.innerComponent" :id="props.block?.anchorId" v-bind="data" />
</template>
